import React, { Fragment, useEffect, useState } from "react";

import "@/styles/dashboard/my-dashboard.scss";
import CardComponent from "@/components/card";
import Container from "@/components/container/Container";
import { Col, Divider, Flex, Popover, Progress, Row } from "antd";
import IconSessionName from "@/components/icons/IconSessionName";
import IconCalender from "@/components/icons/IconCalender";
import IconSessionTime from "@/components/icons/IconSessionTime";
import IconDuration from "@/components/icons/IconDuration";
import IconUserProfile from "@/components/icons/IconUserProfile";
import IconSession from "@/components/icons/IconSession";
import IconAddExpert from "@/components/icons/IconAddExpert";
import ButtonComponent from "@/components/button/Button";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserInfo,
  setCurrentForm,
  setFormProps,
  setModalOpen,
} from "@/reducers/commonSlice";
import { getCheckoutType } from "@/reducers/checkoutSlice";
import { getBookedSessions } from "@/services/users/getBookedSessions";
import Resources from "@/components/resources/Resources";
import PurchaseCard from "@/components/DashboardDrawer/PurchaseCard";
import { getStudentTasks } from "@/services/students/getStudentTasks";
import { getGuideProfile } from "@/services/guides/getGuideProfile";
import { convertToLocalTime } from "@/helpers";
import useTriggerNotification from "@/hooks/useTriggerNotification";
import { getCountryTimeZone } from "@/helpers/getCountryZone";
import BackWithLabel from "@/components/common/BackWithLabel";
import { getIsGuidePanel, setCurrentGuide, setIsGuidePanel } from "@/reducers/guideSlice";
import IconReschedule from "@/components/icons/IconReshedule";
import { isWithin24Hours } from "@/pages/session/sessionUtils";
import { rescheduleSession } from "@/services/students/session";
import moment from "moment";
import { showNotification } from "@/components/toaster/Toaster";
import IconDots from "@/components/icons/IconDots";
import IconReport from "@/components/icons/IconReport";
import { crateReport } from "@/services/users/getReportCategory";

const MyDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { trigger, element } = useTriggerNotification();
  const [sessionData, setSessionData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentIntent = searchParams.get("payment_intent");
  const isProductType = useSelector(getCheckoutType);
  const [timezone, setTimezone] = useState();
  const isGuidePanel = useSelector(getIsGuidePanel);
  const userData = useSelector(getUserInfo);
  const isGuideRole = userData?.roles?.find((x) => x.name === "Guide");

  const [taskCompleted, setTaskCompleted] = useState({
    totalTask: 0,
    completedTask: 0,
    progress: 0,
  });

  const handlePaymentSuccess = () => {
    dispatch(setModalOpen(true));
    if (isProductType) {
      dispatch(setCurrentForm("productSuccess"));
    } else {
      dispatch(setCurrentForm("sessionSuccess"));
    }
    setSearchParams();
  };

  useEffect(() => {
    if (!!paymentIntent) {
      handlePaymentSuccess();
    }
  }, [paymentIntent]);

  useEffect(() => {
    const fromCheckout = sessionStorage.getItem("fromCheckout");

    if (fromCheckout) {
      sessionStorage.removeItem("fromCheckout");

      window.history.replaceState(null, "", "/dashboard");
      const handleBackButton = (event) => {
        event.preventDefault();
        navigate("/plans", { replace: true });
      };
      window.addEventListener("popstate", handleBackButton);
      return () => {
        window.removeEventListener("popstate", handleBackButton);
      };
    }
  }, [navigate]);

  const getTotalTask = (res) => {
    return res.filter((x) => {
      return x.userId !== (x.assignedBy.id || x.assignedBy);
    });
  };

  const fetchData = () => {
    getBookedSessions()
      .then((res) => {
        const responseClone = [...res];
        const updatedData = responseClone?.map((x) => {
          return {
            ...x,
            ...convertToLocalTime(x.date, x.time),
          };
        });
        setSessionData([...updatedData]);
      })
      .catch((error) => console.log(error));

    getStudentTasks()
      .then(async (res) => {
        const filteredResponse = getTotalTask(res);
        const totalTask = filteredResponse.length ?? 0;
        const totalTaskCompleted = filteredResponse.filter((x) => x.completedAt).length ?? 0;
        // const taskIds = res?.map((x) => x.taskId);
        // const taskResponse = await getTaskById(taskIds);
        const pendingTasks = filteredResponse.filter((x) => !x.completedAt);

        const taskTitleMap = filteredResponse.reduce((acc, task) => {
          acc[task.taskId] = task.title;
          return acc;
        }, {});

        // Get the titles of the pending tasks by matching task IDs
        const pendingTaskTitles = pendingTasks.map((task) => taskTitleMap[task.taskId]);

        setTaskCompleted({
          totalTask: totalTask,
          completedTask: totalTaskCompleted,
          progress: totalTask ? Math.ceil((totalTaskCompleted / totalTask) * 100) : 0,
          taskTitle: pendingTaskTitles,
        });
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleJoinSession = (id) => {
    navigate(`/lobby/${id}`);

    // getRoomCodeBySession(id)
    //   .then((res) => {
    //     if (res.roomCode) {
    //       navigate(`/sessions/${res.roomCode}`);
    //     }
    //   })
    //   .catch((err) => console.log(err));
  };

  const handleCopyToClipboard = (id) => {
    const path = window.location.origin + "/parent/lobby" + id;
    navigator.clipboard.writeText(path).then(() => {
      trigger({
        type: "success",
        message: "Link Copied to Clipboard",
      });
    });
  };

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  const handleSwitchToGuidePanel = () => {
    dispatch(setIsGuidePanel(!isGuidePanel));
    navigate("/dashboard");
  };
  const onReportClick = (sessionId) => {
    dispatch(setCurrentForm("report"));
    dispatch(
      setFormProps({
        categoryType: "Session",
        handleSubmit: (data) => {
          if (data.categoryId && data.description) {
            data.metadata = { sessionId };
            crateReport(data).then((res) => {
              console.log(res);
              dispatch(setModalOpen(false));
              dispatch(setCurrentForm("successModal"));
              dispatch(setModalOpen(true));
              dispatch(
                setFormProps({
                  message: "Your report has been submitted successfully.",
                  btnLabel: "Close",
                  onSubmit: () => {
                    dispatch(setModalOpen(false));
                  },
                })
              );
            });
          }
        },
      })
    );
    dispatch(setModalOpen(true));
  };

  const handleRescheduleSession = async (sessionItem) => {
    console.log("sessionItem", sessionItem);
    const guideData = await getGuideProfile(sessionItem.guideId);
    if (isWithin24Hours(sessionItem)) {
      console.log("Cannot reschedule session");
      dispatch(setCurrentForm("requestWithReason"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          message: "Are you sure you want to request a session reschedule?",
          onSubmit: (data) => {
            console.log("data", data);
            const payload = {
              reason: data.comment,
              bookingId: sessionItem.id,
            };
            rescheduleSession(payload)
              .then((res) => {
                console.log("reschedule request registered", res);
                fetchData();
                showNotification(
                  "success",
                  "Registered!",
                  "Your reschedule request has been registered."
                );
              })
              .catch((err) => console.log(err));
            dispatch(setModalOpen(false));
          },
        })
      );
    } else {
      dispatch(setCurrentForm("bookASession"));
      dispatch(
        setFormProps({
          selectedDateProp: moment(sessionItem.date),
          durationProp: sessionItem.duration === 30 ? "30min" : "60min",
          isUpdate: true,
          handleUpdateSession: async (data) => {
            const payload = {
              date: moment(data.date).format("YYYY-MM-DD"),
              bookingId: sessionItem.id,
              timeslots: data.time.map((x) => {
                return {
                  start: x.start,
                  end: x.end,
                };
              }),
            };
            console.log("data to be updated", data);
            rescheduleSession(payload)
              .then((res) => {
                console.log("reschedule done", res);
                fetchData();
                showNotification("success", "Rescheduled!", "Your session has been rescheduled.");
              })
              .catch((err) => console.log(err));
          },
        })
      );
      dispatch(setCurrentGuide(guideData));
      dispatch(setModalOpen(true));
    }
  };
  const content = ({ id }) => {
    return (
      <div className="menulink-popover">
        <Flex
          align="center"
          gap="0.5rem"
          className="color-brand cursor-pointer"
          onClick={() => {
            // dispatch(setModalOpen(true))
          }}
        >
          <IconReport />
          <span onClick={() => onReportClick(id)}>Report</span>
        </Flex>
      </div>
    );
  };
  return (
    <Fragment>
      {element}
      <div className="dashboard-wrapper">
        <Container>
          <div className="dashboard-outer-card">
            <CardComponent className="dashboard-outer-card-body">
              {!userData?.verified?.email ? (
                <p
                  style={{
                    color: "red",
                    fontSize: "16px",
                    fontWeight: "bold",
                    margin: "10px 0",
                  }}
                >
                  ⚠️ Your email is not verified. Please{" "}
                  <Link
                    to="/profile/basic-contact-information"
                    style={{
                      color: "red",
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    verify your email
                  </Link>
                  .
                </p>
              ) : null}
              <div className="dashboard-inner-card">
                <CardComponent>
                  {isGuideRole && isGuideRole.isApproved ? (
                    <Flex
                      className="header"
                      justify="space-between"
                      align="center"
                      style={{ flexWrap: "wrap", gap: "10px" }}
                    >
                      <BackWithLabel label="Dashboard" />
                      {/* <button
                        className="color-brand cursor-pointer"
                        onClick={handleSwitchToGuidePanel}
                      >
                        Switch to Mentor dashboard
                      </button> */}
                      <ButtonComponent
                        label="Switch to Mentor dashboard"
                        varient="primary"
                        onClick={handleSwitchToGuidePanel}
                      />
                    </Flex>
                  ) : (
                    <></>
                  )}
                  <div className="resources">
                    <Row gutter={[4, 4]}>
                      <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
                        <div className="heading body-b3">My upcoming sessions</div>
                      </Col>
                      <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}>
                        <Divider />
                      </Col>
                    </Row>
                  </div>
                  {sessionData.length ? (
                    <>
                      <div className="sessions">
                        <Row gutter={[16, 16]}>
                          {sessionData?.slice(0, 3).map((item, index) => {
                            return (
                              <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24} key={index}>
                                <div className="session-outer-card">
                                  <CardComponent>
                                    <div className="session-inner-card">
                                      <CardComponent>
                                        {/* <div className="heading title-h5-1">
                                      {item.title}
                                    </div> */}

                                        {/* <Divider /> */}

                                        <Flex justify="space-between">
                                          <Flex gap="5px" className="sesstion-name">
                                            <IconSessionName />
                                            {/* <span>Session Name:</span> */}
                                            {item.name}
                                          </Flex>
                                          <Popover
                                            placement="bottomRight"
                                            content={content({
                                              id: item.id,
                                            })}
                                            // open={openId === index}
                                            trigger="hover"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <IconDots className="cursor-pointer" on />
                                          </Popover>
                                        </Flex>

                                        {/* <div className="session-date-time"> */}
                                        <Flex gap="5px" className="session-date">
                                          <IconCalender />
                                          <span>Date:</span>
                                          {item.date}
                                        </Flex>

                                        <Flex gap="5px" className="session-time">
                                          <IconSessionTime />
                                          <span>Time:</span>
                                          {item.time} {timezone ? `(${timezone})` : ""}
                                        </Flex>
                                        {/* </div> */}

                                        {/* <div className="session-more"> */}
                                        <Flex gap="5px" className="session-duration">
                                          <IconDuration />
                                          <span>Duration:</span>
                                          {item.duration} Minutes
                                        </Flex>

                                        <Flex gap="5px" className="guide-name">
                                          <IconUserProfile />
                                          <span>Mentor:</span>
                                          {item.guideName}
                                        </Flex>
                                        {/* </div> */}

                                        <div className="session-button">
                                          <ButtonComponent
                                            varient="primary"
                                            label="Join Session"
                                            iconRight={false}
                                            onClick={() => handleJoinSession(item.id)}
                                          >
                                            <IconSession
                                              width="24px"
                                              height="24px"
                                              color="#fdfefe"
                                            />
                                          </ButtonComponent>
                                        </div>
                                        <Row gutter={[4, 4]}>
                                          <Col xs={24}>
                                            <div className="session-button">
                                              <ButtonComponent
                                                label="Invite Parents"
                                                iconRight={false}
                                                onClick={() => handleCopyToClipboard(item.id)}
                                              >
                                                <IconAddExpert
                                                  width="24px"
                                                  height="24px"
                                                  color="#db5800"
                                                />
                                              </ButtonComponent>
                                            </div>
                                          </Col>
                                          <Col xs={24}>
                                            <div className="session-button">
                                              <ButtonComponent
                                                label="Reschedule Session"
                                                iconRight={false}
                                                onClick={() => handleRescheduleSession(item)}
                                              >
                                                <IconReschedule
                                                  width="20px"
                                                  height="20px"
                                                  color="#db5800"
                                                />
                                              </ButtonComponent>
                                            </div>
                                          </Col>
                                        </Row>
                                      </CardComponent>
                                    </div>
                                  </CardComponent>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </>
                  ) : (
                    <div className="sessions no-session-booked">
                      <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                        <div className="session-outer-card">
                          <CardComponent>
                            <div className="session-inner-card">
                              <CardComponent>
                                <img src="/assets/images/availbility.png" />
                                <div className="title-h4">No Sessions Booked Yet?</div>
                                <div className="body-b12 sublabel">
                                  Discover the perfect session for your study abroad journey. Book
                                  now!
                                </div>
                                <div className="session-button">
                                  <ButtonComponent
                                    label="Book Session Now"
                                    varient="primary"
                                    onClick={() => navigate("/guides")}
                                  />
                                </div>
                              </CardComponent>
                            </div>
                          </CardComponent>
                        </div>
                      </Col>
                    </div>
                  )}
                  <div className="resources">
                    <Row gutter={[4, 4]}>
                      <Col xxl={3} xl={3} lg={3} md={4} sm={24} xs={24}>
                        <div className="heading body-b3">My Resources</div>
                      </Col>
                      <Col xxl={21} xl={21} lg={21} md={20} sm={24} xs={24}>
                        <Divider />
                      </Col>
                    </Row>
                    <div className="resources-buttons">
                      <Resources />
                    </div>
                  </div>
                  <div className="dashboard-footer">
                    <Row gutter={[16, 16]}>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <CardComponent>
                          <Row gutter={[4, 4]}>
                            <Col xxl={8} xl={8} lg={10} md={6} sm={24} xs={24}>
                              <div className="heading body-b3">My Tasks Progress</div>
                            </Col>
                            <Col xxl={16} xl={16} lg={16} md={14} sm={24} xs={24}>
                              <Divider />
                            </Col>
                          </Row>
                          <div className="progress-details">
                            <Flex align="center" gap="0.5rem">
                              <Progress
                                percent={taskCompleted.progress}
                                showInfo={false}
                                strokeColor="#262321"
                                strokeWidth={14}
                                style={{ width: "90%" }}
                              />
                              <span className="body-b2">{taskCompleted.progress}%</span>
                            </Flex>
                            <div className="heading body-b4">
                              In progress task: (
                              {taskCompleted.totalTask - taskCompleted.completedTask}/
                              {taskCompleted.totalTask})
                            </div>

                            {taskCompleted.progress === 100 ? (
                              <div style={{ color: "green" }}>All tasks completed.</div>
                            ) : (
                              <div className="task-chips">
                                {taskCompleted?.taskTitle?.map((x, i) => {
                                  return (
                                    <div className="chip body-b4" key={i}>
                                      {x}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </CardComponent>
                      </Col>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <CardComponent>
                          <Row gutter={[4, 4]}>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                              <div className="heading body-b3">My Purchase</div>
                            </Col>
                            <Col xxl={18} xl={18} lg={18} md={18} sm={24} xs={24}>
                              <Divider />
                            </Col>
                          </Row>
                          <PurchaseCard />
                          {/* <div className="visa-content">
                            <div className="heading body-b1">
                              Visa assistance
                            </div>
                            <div className="content body-b4">
                              End-to-end visa process assistance for studying
                              abroad.
                            </div>
                          </div> */}
                          {/* <div className="explore-button">
                            <ButtonComponent label="Explore Other Plans & Offerings" />
                          </div> */}
                        </CardComponent>
                      </Col>
                    </Row>
                  </div>
                </CardComponent>
              </div>
            </CardComponent>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default MyDashboard;
